<script>
    import { getContext } from 'svelte';

    export let timelineKey;

    const {
        tooltip,
        time_range,
        timeScale,
        selector,
        stops,
        car,
        h,
        trajectory,
        geo_distance,
    } = getContext(timelineKey);
    const active_item = selector.active_item;

    $: selected_stops = Object.keys($stops)
        .filter((key) => $stops[key].car == $car)
        .map((key) => $stops[key]);
    $: movements = extract_movements(selected_stops);

    $: shown_stops = selected_stops.filter((s) => {
        const pass_start = s.start.timestamp < $time_range[1];
        const pass_stop = s.stop.timestamp > $time_range[0];
        return pass_start && pass_stop;
    });
    $: shown_movements = movements.filter((s) => {
        const pass_start = s.start.timestamp < $time_range[1];
        const pass_stop = s.stop.timestamp > $time_range[0];
        return pass_start && pass_stop;
    });

    function extract_movements(stops) {
        let movements = [];
        for (let i = 1; i < stops.length - 1; ++i) {
            const start = stops[i - 1].stop;
            const stop = stops[i].start;
            const duration = (stop.timestamp - start.timestamp) / 1000; // seconds
            const distance = geo_distance(
                start.lat,
                start.long,
                stop.lat,
                stop.long
            ); // meter
            const speed = (distance / duration) * 3.6; // km/h
            movements.push({
                car: $car,
                start,
                stop,
                duration,
                distance,
                speed,
            });
        }
        return movements;
    }

    function width(d, range) {
        return (
            timeScale(d.stop.timestamp, range) -
            timeScale(d.start.timestamp, range)
        );
    }

    function is_active(item, active_item) {
        return !active_item || item._key == active_item._key;
    }
</script>

{#each shown_movements as s}
    <rect
        class="stoprect"
        x={timeScale(s.start.timestamp, $time_range)}
        y="1"
        width={width(s, $time_range)}
        opacity={is_active(s, $active_item) ? 1 : 0}
        height={h - 2}
        fill={'#001219'}
        on:mouseenter={(e) => {
            $tooltip.start(e, s);
            $trajectory.show(s);
        }}
        on:mouseleave={() => {
            $tooltip.stop();
            $trajectory.hide();
        }}
        on:click={() => selector.select(s)}
        on:mousemove={(e) => {
            $tooltip.move(e);
            const time = +timeScale.invert(e.offsetX);
            $trajectory.highlight(time);
        }}
    />
{/each}

{#each shown_stops as s}
    <rect
        class="stoprect"
        x={timeScale(s.start.timestamp, $time_range)}
        y="10"
        width={width(s, $time_range)}
        opacity={is_active(s, $active_item) ? 1 : 0.1}
        height={h - 20}
        fill={s.state === 'rejected' ? '#ae2012' : '#e9d8a6'}
        on:mouseenter={(e) => {
            $tooltip.start(e, s);
            selector.hover(s);
        }}
        on:mouseleave={() => {
            $tooltip.stop();
            selector.hover(null);
        }}
        on:click={() => selector.select(s)}
        on:mousemove={$tooltip.move}
    />
{/each}
